import { useCallback, useEffect, useRef, useState } from "react";
import { banUser } from "../../services/communityService";
import { getMemberStatus } from "../../services/membersAdminService";
import { MemberStatus } from "./models/MemberStatus";

export const useMemberStatus = (userId?: number) => {
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState<MemberStatus | null>(null);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const load = useCallback(async () => {
        if(loading || !userId)
            return;
        try {
            setLoading(true);
            const _data: MemberStatus = await getMemberStatus(userId);
            if(!isMountedRef.current)
                return;
            if(!!_data)
                setStatus(_data);
        }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }, [userId]);

    const ban = async (type: "temporary" | "permanent", duration: number, reason: string) => {
        if(!userId)
            return;
        return banUser(userId, type, duration, reason).then(() => load());
    }

    useEffect(() => {
        load();
    }, [load]);

    return { loading, status, reload: load, banUser: ban }
}